export default {
  src: 'https://res.cloudinary.com/ditbeukyz/image/upload/v1605878200/Resources/placeholder.svg?cratio=16x9',
  shape: 'natural',
  alt: '',
  width: 'fluid',
  customWidth: {
    desktop: {
      value: 400,
      unit: 'px'
    }
  },
}
